import { delegate } from 'tippy.js'

let trackingBound = false
const initializedRoots = new WeakSet()

export default function initShopTheLook() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true })
    } else {
        run()
    }
}

function bindTracking() {
    if (trackingBound) return
    trackingBound = true

    document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-shopthelook-link]')
        if (!link) return

        if (typeof window.gtag === 'function') {
            window.gtag('event', 'shopthelook_click', {
                product_title: link.dataset.productTitle,
                product_slug: link.dataset.productSlug,
                campaign: link.dataset.campaign,
                link_url: link.href,
            })
        }
    })
}

function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

function buildCard(pin) {
    if (!pin) return ''
    const { pinTitle, pinPrice, pinHref, pinSlug, pinCampaign, pinLinkLabel } = pin.dataset
    if (!pinTitle) return ''

    const parts = [`<div class="c-pin__card-title">${escapeHtml(pinTitle)}</div>`]

    if (pinPrice) {
        parts.push(`<div class="c-pin__card-price">${escapeHtml(pinPrice)}</div>`)
    }

    if (pinHref) {
        parts.push(
            `<a class="c-pin__card-link" href="${escapeHtml(pinHref)}" data-shopthelook-link` +
            ` data-product-title="${escapeHtml(pinTitle)}"` +
            ` data-product-slug="${escapeHtml(pinSlug ?? '')}"` +
            ` data-campaign="${escapeHtml(pinCampaign ?? '')}">` +
            `${escapeHtml(pinLinkLabel || 'Bekijk product')}</a>`
        )
    }

    return parts.join('')
}

function run() {
    const roots = document.querySelectorAll('.c-shopthelook')
    if (!roots.length) return

    bindTracking()

    const isTouch = window.matchMedia('(hover: none)').matches
    const trigger = isTouch ? 'click' : 'mouseenter focus'

    roots.forEach((root) => {
        if (initializedRoots.has(root)) return
        initializedRoots.add(root)

        const instances = []

        delegate(root, {
            target: '.c-pin__trigger',
            content: (reference) => buildCard(reference.closest('.c-pin')),
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            placement: 'top',
            theme: 'shopthelook',
            trigger,
            hideOnClick: true,
            maxWidth: 230,
            offset: [0, 8],
            popperOptions: {
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top', 'bottom', 'right', 'left'],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: { padding: 8 },
                    },
                ],
            },
            onCreate(inst) {
                instances.push(inst)
            },
            onShow(inst) {
                instances.forEach((other) => {
                    if (other !== inst) other.hide()
                })
            },
        })
    })
}
